import { EventEmitter } from '@teamwork/util';

export const eventBus = new EventEmitter();
